<!-- 新房--详情--户型介绍详情 -->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
      <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>
    <!-- 户型详情 -->
    <div class="saleDetail">
      <div class="title">
        <div :class="isIndex == index ? 'title-items' : 'title-item'" v-for="(item, index) in titleList" :key="index" @click="linkPage(item.url, 'id', id)">
          {{ item.typeName }}
        </div>
      </div>
    </div>
    <div class="saleDetail">
       <div class="news-left">
        <div  class="salesImg" v-for="(item, index) in houseDetail.album" :key="'A'+ index">
          <img :src="item"  v-show="index == leftIndex"  style="width: 630PX;height: 430PX;">
        </div>
        <div class="swiper-container card-carousel-cardes">
        <div class="swiper-wrapper">
          <div class="swiper-slide card-carousel-carde" style="width: 160px;height: 120px;" :class="leftIndex == index?'littles':'little'" v-for="(item,index) in houseDetail.album" :key="'B' + index" @click="clickImg(index)">
            <img :src="item" alt="" class="img">
          </div>
        </div>
      </div>

       </div>
       <div class="sale-right">
         <div class="name">
            {{houseDetail.houseName}}
         </div>
         <div class="inShou">
            <div class="shou" v-for="(item, index) in houseDetail.character" :key="index">{{item}}</div>
         </div>
         <div class="hs">
           <div class="hui"> 价格</div>
           <div class="price"> <p class="big">{{houseDetail.price}}</p>元/m²</div>
         </div>
         <div class="hs">
           <div class="hui"> 居室</div>
           <div> {{houseDetail.room}}</div>
         </div>
         <div class="hs">
           <div class="hui">层高</div>
           <div>{{houseDetail.height}}</div>
         </div>
         <div class="hs">
           <div class="hui"> 面积</div>
           <div> {{houseDetail.area}}m²</div>
         </div>
         <div class="hs">
           <div class="hui"> 户型解读</div>
           <div class="jiedu"> {{houseDetail.explain}}</div>
         </div>
         <div class="more">
           <!-- 查看更多楼盘详情 > -->
         </div>
         <div class="telItem">
            <div class="tel-left">
              <div class="tel-up">
                <div class="tel-img">
                  <img src="../../../static/pC/phone.png" alt="" class="img">
                </div>
                <div class="tel-phone">
                  <div class="bigg">
                    {{houseDetail.phoneNumber}}转{{houseDetail.phoneTurnNumber}}
                  </div>
                  <div class="lv">
                    安全通话隐藏真实号码，致电售楼处了解更多信息
                  </div>
                </div>
              </div>
              <div class="tel-but">
                <div class="but-left">
                  预约通话
                </div>
                <div class="but-right">
                  预约看房
                </div>
              </div>
            </div>
            <div class="tel-right">
              <div class="erweima">
                <img :src="houseDetail.contactImage" alt="" class="img">

              </div>
              <div class="es">
                扫码致电售楼部
              </div>
            </div>
         </div>
       </div>
    </div>
    <!-- 一室 -->
    <div class="albums">
      <div class="albums-l">楼盘户型</div>
      <div class="activities-r">
        <div class="activities-l" v-for="(item, index) in houseType" :key="index" >
          <div class="text"> {{item.typeName}}</div>
          <div class="xian"> | </div>
        </div>
        <div class="more">
          查看更多 >
        </div>
      </div>
    </div>
    <div class="albumsImg">
      <div class="albumsItem" v-for="(item, index) in houseList.slice(0,4)" :key="index" @click="saleDetail(index)">
        <div class="imgItems">
          <img :src="item.image" alt="" class="imgsw" >
        </div>
          <div class="albumsNames">
            <div class="names">{{item.houseName}}</div>
            <div class="on">{{item.saleStatus}}</div>
            <div class="zhu" v-if="item.mainPush==0">普通</div>
            <div class="zhu" v-if="item.mainPush==1">主推</div>
          </div>
          <div class="jian">
            建筑面积：{{item.area}}m²
          </div>
          <div class="albumsBut">询余房</div>
      </div>
    </div>
    <div style="height: 80px;"></div>

    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from "../../components/HeaderNav";
import FooterNav from "../../components/FooterNav";
import Banners from "../../components/Banners.vue";
import RightNav from '../../components/RightNav.vue';
import { getHouseDetail, apiChangeOther, apiAddNotes } from "../../api/job.js";
export default {
  name: "Index",
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    RightNav:RightNav,
  },
  data() {
    return {
      advertInfo: { image: "../../static/pC/ad.png" },
     titleList: [
       { typeName: '楼盘首页', url: '/jobDetail' },
       { typeName: '楼盘详情', url: '/SaleDetail' },
       { typeName: '楼盘相册', url: '/BuildImg' },
       { typeName: '户型介绍', url: '/HouseType' },
       { typeName: '用户点评', url: '/evaluate' },
       // { typeName: '周边配套', url: '' },
       { typeName: '楼盘动态', url: '/Dynamics' }
     ],
      houseList:[],
      houseType:[],
      isIndex:3,
      leftIndex: 0,
      id:'',
      houseDetail:'',
      bannerLists:[
        {avatar:'../../../static/pC/1.png',title:''},
        {avatar:'http://yghf-api.bainaonline.cn/protected/downloads/20210831/16304015244415622612df3f4cb9d0.jpg',title:''},
        {avatar:'http://yghf-api.bainaonline.cn/protected/downloads/20210831/16304015244415622612df3f4cb9d0.jpg',title:''},
        {avatar:'http://yghf-api.bainaonline.cn/protected/downloads/20210831/16304015244415622612df3f4cb9d0.jpg',title:''},
        {avatar:'http://yghf-api.bainaonline.cn/protected/downloads/20210831/16304015244415622612df3f4cb9d0.jpg',title:''},
      ],
      houesImgList:[
        {img:'../../../static/pC/qqq.jpg',name:'c2 3室2厅2卫'},
        {img:'../../../static/pC/qqq.jpg',name:'c2 3室2厅2卫'},
      ],
      flag: false, //导航按钮是否到最末尾
      flag1: true, //导航按钮是否到最开
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.typeId = this.$route.query.typeId;
    this.judgeLogin();
    this.getAd()

  },
  methods: {
    getAd(){
      this.$loading();
      let  _this = this
      getHouseDetail({
        houseId:this.typeId,
      }).then((res) => {
        this.advertInfo = res.data.advertInfo
        this.houseDetail = res.data.houseDetail;
        this.houseList = res.data.houseList
        this.houseType = res.data.houseType
        this.$nextTick(() => {
        //等页面刷新完之后，再执行回调函数中的方法
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: '.prev',
            prevEl: '.next'
          },
          on: {
            slideChangeTransitionEnd: function() {
              if (this.isEnd) {
                _this.flag = true;
              } else {
                _this.flag = false;
              }
              if (this.isBeginning) {
                _this.flag1 = true;
              } else {
                _this.flag1 = false;
              }
            }
          }
        });
        });
        this.$loading().close();
      })
        .catch((err) => {
          this.$loading().close();
        });
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },

    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key }},  onComplete => {}, onAbort => {});
      }
    },

    linkDetail(index){
      this.isIndex = index
      if(this.isIndex==0){
         this.$router.push({ path: "/jobDetail" });
      }
      if(this.isIndex==1){
         this.$router.push({ path: "/SaleDetail" });
      }
      if(this.isIndex==2){
         this.$router.push({ path: "/BuildImg" });
      }
      if(this.isIndex==3){
         this.$router.push({ path: "/HouseType" });
      }
    },
    clickImg(index) {
      this.leftIndex = index;
    },

    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
  }
};
</script>
<style scoped>
/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
/* 楼盘详情 */
.saleDetail{
  max-width: 1200px;
  margin: 30px  auto 0 auto;
  display: flex;
}
.saleDetail .title{
  width: 100%;
  background-color: #345c4e;
  color: #fff;
  display: flex;
  align-items: center;
  height: 50px;;
}
.saleDetail .title .title-item{
  width: 130px;
  text-align: center;
}
.saleDetail .title .title-items{
  width: 130px;
  text-align: center;
  background-color: #A98C60;
  height: 50px;
  line-height: 50px;
}
.detailItem{
  width: 630PX;
  height: 430PX;
}
.news-left{
  width: 630PX;
}
.salesImg{
  /* width: 630px; */
  /* height: 460px; */
}
.saleImg{
  width: 630px;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
  display:flex ;

}
::-webkit-scrollbar {
   display: none
}
.saleImg .little{
  padding: 0;
  margin-right: 10px;
  margin-top: 10px;
}
.saleImg .littles{
  border: 3px solid #345C4E;
  margin-right: 10px;
  margin-top: 10px;
}
.saleImg .littles .img{
  width: 160px;
  height: 120px;

}
.saleImg .little .img{
  width: 160px;
  height: 120px;

}
.jiedu{
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sale-right{
  padding: auto;
  margin-left: 30PX;
}
.sale-right .name{
  font-size: 30px;
  font-weight: bold;
}
.sale-right .inShou{
  margin: 10px 0;
  display: flex;
  align-items: center;

}
.sale-right .inShou .shou{
  margin-right: 10px;
}
.sale-right .hs{
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.sale-right .hs .hui{
  color: #999999;
  margin-right: 20px;

}
.sale-right .hs .price{
  display: flex;
  align-items: center;
  color: #345C4E;
}
.sale-right .hs .price .big{
  font-size: 30px;
}
.sale-right .more{
  margin: 35px 0;
  color: #345C4E;
  padding: 20px 0;
}
.on {
  padding: 0px 5px;
  margin-left: 10px;
  color: #a98c60;
  background-color: #e4dbce;
  font-size: 12px;
}
.zhu {
  padding: 0px 5px;
  margin-left: 5px;
  color: #345c4e;
  border: 1px solid #345c4e;
  font-size: 12px;
}
.telItem{
  width: 530px;
  height: 180px;
  display: flex;
  padding: 20px;
  background-color: #EAEEED;
}
.telItem .tel-left{
  padding: 0;
}
.telItem .tel-left .tel-up{
  display: flex;
  align-items: center;
}
.telItem .tel-left .tel-up .bigg{
  font-size: 30px;
  color: #345C4E;
}
.telItem .tel-left .tel-up .lv{
  margin-top: 15px;
  font-size: 14px;
  color: #345C4E;
}
.telItem .tel-left .tel-but{
  display: flex;
  align-items: center;
  justify-content: center;
}
.telItem .tel-left .but-left{
  background-color: #345C4E;
  color: #fff;
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px;
  margin-top: 20px;
}
.telItem .tel-left .but-right{
  background-color:#A98C60;
  color: #fff;
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px;
  margin-left: 30px;
  margin-top: 20px;
}
.tel-right{
  margin-left: 20px;
  text-align: center;
}
.erweima{
  width: 100px;
  height: 100px;
  border: 1px solid #345C4E;
}
.img{
  width: 100%;
  height: 100%;
}
.es{
  font-size: 14px;
  margin-top: 20px;
}
.adviser{
  max-width: 1200px;
  margin: 0  auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.adviser-s{
  display: flex;
  margin: 20px 0;
}
.adviser-s .mu-name{
  font-size: 22px;
  font-weight: bold;
}
.adviser-a{
 display: flex;
 margin-left: 20px;
}
.adviser-i{
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.adviser-img{
  margin-right: 20px;
}
.adviser-r{
  display: flex;
  align-items: center;
}
.le{
  margin-right: 10px;
}
.consultant{
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #E5E5E5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.consultant-con{
  margin-left: 10px;
}
.consultant-s{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 42%;
}
.consultant-le{
  width: 120px;
  height: 120px;
}
.imgsw{
  width: 120px;
  height: 120px;
}
.consultant-con{
  font-size: 18px;

}
.consultant-phone{
  font-size: 24px;
  margin: 5px 0;
}
.consultant-but{
  display: flex;
  align-items: center;
}
.buts-left{
  background-color: #345C4E;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
}
.buts-right{
  background-color: #A98C60;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  margin-left: 10px;
  font-size: 16px;
}
.eq{
  width: 90px;
  height: 90px;
  border: 1px solid #345C4E;
  margin: 0 auto;
}
.ess{
  margin-top: 10px;
  font-size: 14px;
}
/* 一室 */
.albums{
  width: 1200px;
  margin: 30px auto 20px auto;
  display: flex;
  justify-content: space-between;
}
.albums-l{
  font-size: 20px;
  font-weight: bold;
}
.activities-r{
  display: flex;
}
.activities-l{
  display: flex;
  color: #345C4E;
  font-size: 15px;
}
.more{
  font-size: 14px;
  color: #666;
}
.xian{
  margin: 0 20px;
}
.albumsImg{
  width: 1200px;
  margin: 0  auto;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.albumsItem{
  width: 24%;
  padding: 0;
  text-align: center;
  margin-right: 20px;
}
.imgItem{
  width: 280px;
  height: 220px;
}
.imgItems{
  width: 280px;
  height: 280px;
  border: 1px solid #e5e5e5;
}
.imgsw{
  width: 100%;
  height: 100%;
}
.albumsName{
  margin-top: 20px;
}
.albumsNames{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.names{
  font-size: 16px;
  font-weight: bold;
}
.jian{
  margin-top: 20px;
}
.albumsBut{
  width: 98%;
  color: #fff;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #345C4E;
  margin-top: 20px;
}


.card-carousel-cardes {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}

.card-carousel-cardes .card-carousel-carde {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-carousel-cardes .card-carousel-carde:hover {
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
}
.card-carousel-cardes .card-carousel-carde:first-child {
  margin-left: 0;
}
.card-carousel-cardes .card-carousel-carde:last-child {
  margin-right: 0;
}
.card-carousel-cardes .card-carousel-carde img {
  max-width: 100%;
  height: 120px;
  vertical-align: bottom;
  display: flex;
}
.card-carousel-cardes .card-carousel-carde img:hover {
  opacity: 0.5;
}









/* 楼盘推荐 */
.recommend {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
}
.recommend .t {
  width: 100%;
}
.recommend .swiper-button-group {
}
.recommend .swiper-button-group .btnswiper {
  width: 30px;
  height: 30px;
}
.recommend .swiper-button-group .btnswiper img {
  width: 12px;
  height: 20px;
}
.recommend .swiper-button-group .prev {
  margin-left: 20px;
}
.recommend .swiper-button-group .next-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .next-green {
  background: #345c4e;
}
.recommend .swiper-button-group .prev-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .prev-green {
  background: #345c4e;
}
.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}

.card-carousel-cards .card-carousel--card {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-carousel-cards .card-carousel--card:hover {
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  max-width: 100%;
  height: 227px;
  vertical-align: bottom;
  display: flex;
}
.card-carousel-cards .card-carousel--card img:hover {
  opacity: 0.5;
}
.card-carousel-cards .card-carousel--card .n {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.card-carousel-cards .card-carousel--card .money {
  font-size: 16px;
  font-weight: bold;
  color: #345c4e;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Job/HouseTypeDetail.vue